import { Injectable } from '@angular/core';
import * as cryptoJS from 'crypto-js';

import { baseCode } from 'src/app/app.constants';

@Injectable()
export class StorageService {
  private prefix = 'hb3';

  constructor() {}

  public getPrefix(): string {
    return this.prefix;
  }
  /**
   * Save value in navigator storage (localStorage by default)
   *
   * @param key - Name of data
   * @param value - Related value
   * @param [isSession=false] - If set true, data will be saved in sessionStorage
   */
  public setItem(key: string, value: any, isSession: boolean = false): void {
    const cipherData: any = cryptoJS.AES.encrypt(
      JSON.stringify(value),
      atob(baseCode),
    );

    if (!isSession) {
      localStorage.setItem(`${this.prefix}-${key}`, String(cipherData));
    } else {
      sessionStorage.setItem(`${this.prefix}-${key}`, String(cipherData));
    }
  }

  /**
   * Get value from navigator storage (localStorage by default)
   *
   * @param key - Name of data
   * @param isJSON - Whether data is JSON or not
   * @param [isSession=false] - If set true, data will be gotten from sessionStorage
   * @returns data
   */
  public getItem(
    key: string,
    isJSON?: boolean,
    isSession: boolean = false,
  ): any {
    const storageData: any = !isSession
      ? localStorage.getItem(`${this.prefix}-${key}`)
      : sessionStorage.getItem(`${this.prefix}-${key}`);

    const dataItem = this.decriptStorageData(storageData, isJSON);
    return dataItem;
  }

  public decriptStorageData(storageData: any, isJSON?: boolean): any {
    if (!storageData) {
      return undefined;
    }

    const decipherData: cryptoJS.DecryptedMessage = cryptoJS.AES.decrypt(
      storageData,
      atob(baseCode),
    );
    const decipherText: string = decipherData.toString(cryptoJS.enc.Utf8);
    // FIXME: Add a type to this storageData
    const data: any = isJSON ? JSON.parse(decipherText) : decipherText;

    return data;
  }

  /**
   * Clear data from navigator storage (localStorage by default)
   *
   * @param [isSession=false] - If set true, sessionStorage data will be cleared
   */
  public clear(isSession: boolean = false): void {
    if (!isSession) {
      localStorage.clear();
    } else {
      sessionStorage.clear();
    }
  }

  public clearOne(key: string, isSession: boolean = false): void {
    if (!isSession) {
      localStorage.removeItem(`${this.prefix}-${key}`);
    } else {
      sessionStorage.removeItem(`${this.prefix}-${key}`);
    }
  }
}
